import axios from "axios";

export default {
  methods: {
    getAllErrosListagem(id, params) {
      return axios.get(
        this.CriarUrl({ resource: `validacoes/${id}/erros`, params })
      );
    }
  }
};
